'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _styles = require('./styles');

var _styles2 = _interopRequireDefault(_styles);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var WMText = function WMText(_ref) {
	var inline = _ref.inline,
	    small = _ref.small,
	    style = _ref.style,
	    children = _ref.children;

	var computedStyles = Object.assign({}, (0, _styles2.default)(small), style);
	var component = void 0;

	if (typeof children === 'string') {
		component = _react2.default.createElement(inline ? 'span' : 'p', {
			'data-component-identifier': 'wm-text__' + (inline ? 'span' : 'p'),
			style: computedStyles
		}, children);
	} else {
		component = _react2.default.createElement(
			'div',
			{
				'data-component-identifier': 'wm-text__nodes',
				style: computedStyles
			},
			children
		);
	}

	return component;
};

WMText.defaultProps = {
	small: false
};

exports.default = WMText;


// WEBPACK FOOTER //
// ./~/@workmarket/front-end-components/dist/WMText/index.js